import { createReducer, createActions } from 'reduxsauce';
import storage from 'utils/storage';

/* ------------------- Types and Action Creators -------------- */
const { Types, Creators } = createActions({
  reset: [],
  getGeoCurrentLocation: [],
  login: ['token', 'user', 'noRedirect'],
  logout: [],
  setToken: ['token'],
  setUser: ['user'],
  setForgot: ['phone'],
  setRedirectUrl: ['redirectUrl'],
  saveSignup: ['userData'],
});

export const AuthTypes = Types;

export default Creators;

/* ---------------- Selectors -------------- */
export const AuthSelectors = {
  selectUser: (state) => state.auth.user,
  selectToken: (state) => state.auth.token,
  selectForgot: (state) => state.auth.forgot,
  selectRedirectUrl: (state) => state.auth.redirectUrl,
  selectLoyaltyUser: (state) => state.auth.user.isLoyaltyUser,
  selectSignup: (state) => state.auth.signup,
};

/* ---------------- Initial State -------------- */
export const INITIAL_STATE = {
  forgot: {},
  user: null,
  redirectUrl: '',
  signup: null,
};

/* ---------------- Reducers -------------- */
export const setUser = (state, { user }) => {
  storage.setItem('vemospay-user', JSON.stringify(user));
  return {
    ...state,
    user,
  };
};

export const setForgot = (state, { phone }) => ({
  ...state,
  forgot: { phone },
});

export const setRedirectUrl = (state, { redirectUrl }) => ({
  ...state,
  redirectUrl,
});

export const saveSignup = (state, { userData }) => ({
  ...state,
  signup: userData,
});

export const setToken = (state, { token }) => {
  return {
    ...state,
    token,
  };
};

export const reset = () => ({ ...INITIAL_STATE });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_USER]: setUser,
  [Types.SET_FORGOT]: setForgot,
  [Types.SET_REDIRECT_URL]: setRedirectUrl,
  [Types.RESET]: reset,
  [Types.SAVE_SIGNUP]: saveSignup,
  [Types.SET_TOKEN]: setToken,
});
